import {useDispatch, useSelector, useStore} from 'react-redux';
import {printSlipWithFeedback} from '../../../actions/multiBoxActions';
import {setMultiBoxAlert} from '../../../actions/scanpackScanningActions';
import {isMultiBoxEnabled, getActiveBoxId, getBoxItemCountFromOrder} from '../../../utils/orderHelpers';
import {playNotReadyFeedback} from '../../../utils/scanFeedback';
import {getScannedUnitCount} from '../utils/itemQuantities';
import {useBoxChampGuided} from './useBoxChampGuided';

const guidedEntryOf = (view, pendingConfirmationBoxId) => {
  if (!view) return null;
  const boxId = view.projection.activeBoxId ?? pendingConfirmationBoxId;
  return view.projection.boxes.find(entry => entry.box.id === boxId) || null;
};

const useMultiBoxState = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const currentOrder = useSelector(state => state.scanPackScanning.currentOrder);
  const activeBoxIndex = useSelector(state => state.scanPackScanning.activeBoxIndex);
  const bothSettings = useSelector(state => state.user.bothSettings);
  const {view, pendingConfirmationBoxId} = useBoxChampGuided();

  const generalSettings = bothSettings?.data?.data?.general_setting;
  const multiBox = isMultiBoxEnabled(generalSettings);
  const boxes = currentOrder?.boxes || [];
  const guidedEntry = guidedEntryOf(view, pendingConfirmationBoxId);

  const items = currentOrder?.scanned_items;
  const totalScannedCount = getScannedUnitCount(items || []);

  let currentBoxId = multiBox ? getActiveBoxId(currentOrder, activeBoxIndex) : null;
  let boxScannedCount = multiBox ? getBoxItemCountFromOrder(currentOrder, currentBoxId) : 0;
  let boxOfCount = totalScannedCount;
  let boxName = boxes[activeBoxIndex]?.name || `Box ${activeBoxIndex + 1}`;
  if (guidedEntry) {
    currentBoxId = guidedEntry.box.id;
    boxScannedCount = guidedEntry.filled;
    boxOfCount = guidedEntry.target;
    boxName = guidedEntry.box.name || boxName;
  }
  const showBoxUi = multiBox && (!view || Boolean(guidedEntry));

  const handlePrintSlip = () => {
    if (!currentOrder?.id || !currentBoxId) return;
    const boxItemCount = guidedEntry
      ? guidedEntry.filled
      : (currentOrder?.order_item_boxes || []).filter(entry => entry.box_id === currentBoxId).length;
    if (boxItemCount === 0) {
      dispatch(setMultiBoxAlert(true, true));
      playNotReadyFeedback(store.getState);
      setTimeout(() => {
        dispatch(setMultiBoxAlert(false));
      }, 3000);
      return;
    }
    printSlipWithFeedback(dispatch, store.getState, {
      box_ids: currentBoxId,
      orderArray: [{id: currentOrder.id}]
    });
  };

  return {
    dispatch,
    currentOrder,
    activeBoxIndex,
    multiBox,
    boxes,
    currentBoxId,
    totalScannedCount,
    boxScannedCount,
    boxOfCount,
    boxName,
    showBoxUi,
    guidedView: view,
    guidedEntry,
    handlePrintSlip
  };
};

export default useMultiBoxState;
